import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-org',
  templateUrl: './new-org.component.html',
  styleUrls: ['./new-org.component.css']
})
export class NewOrgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
